import { Form, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';
import Swal from 'sweetalert2';

interface TipoSolicitacaoProps {
  currentSolicitacao?: string;
}

const SelectTipoSolicitacao: React.FC<TipoSolicitacaoProps> = ({ currentSolicitacao }) => {
  const { Option } = Select;
  const [response, setResponse] = useState<any>([]);

  useEffect(() => {
    try {
      tipoSolicitacao.getTiposSolicitacao().then((res) => {
        setResponse(res.data.tiposSolicitacao);
      });
    } catch (error) {
      Swal.fire({
        title:
          'Não foi possivel carregar a lista dos tipos de solicitações, por favor atualize a página!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  response.sort((a: { descricao: string }, b: { descricao: string }) => {
    return a.descricao.toUpperCase() < b.descricao.toUpperCase()
      ? -1
      : a.descricao.toUpperCase() > b.descricao.toUpperCase()
      ? 1
      : 0;
  });

  const tipoSolicitacao = {
    getTiposSolicitacao: (): Promise<AxiosResponse> => UDNICK.callService('getTiposSolicitacao'),
  };

  return (
    <Form.Item
      name="tipoSolicitacao"
      label="Tipo de solicitação"
      rules={[{ required: true, message: 'Selecione a nova solicitação' }]}
    >
      <Select
        defaultValue={currentSolicitacao}
        data-cy="tipoDeSolicitacao"
        style={{ width: '100%' }}
        showSearch
        optionFilterProp={'children'}
        filterOption={(input, option) =>
          option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {response.map((item: any) => (
          <Option value={item.codigo} key={item.codigo}>
            {item.descricao}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectTipoSolicitacao;
